export default {
  checklist: {
    header: {
      feature: "Get Started Checklist",
      heading: "Let's Get Dataships Up and Running!",
    },
    completeButton: {
      cta: "Complete Onboarding",
    },
  },
  steps: {
    installDatashipsApp: {
      title: "1. Install the Dataships Shopify App",
      description:
        "Seamlessly add Dataships to your Shopify store by installing our app from the app store.",
      link: {
        text: "Install App",
      },
    },
    installMatApp: {
      title: "2. Install your Marketing Automation Tool Integration",
      description: "Configure your Integration.",
      link: {
        text: "Install Your Integration",
      },
    },
    configureMatApp: {
      title: "3. Configure your Marketing Automation Tool Integration",
      description:
        "Personalize how Dataships subscribers sync to your marketing lists.",
      link: {
        text: "Configure Your Integration",
      },
    },
    configurePrivacyDetails: {
      title: "4. Add your Privacy Policy Details",
      description:
        "Ensure compliance and transparency by providing accurate privacy policy links and contact details.",
      link: {
        text: "Add Details",
      },
    },
    configureCheckout: {
      title: "5. Disable Shopify Consent",
      description: "Disable your Existing Shopify Consent Collection.",
      link: {
        text: "Disable Shopify Collection",
      },
    },
    configureDatashipsApp: {
      title: "6. Enable Dataships Consent Collection",
      description:
        "Activate Dataships' optimized consent collection and instantly enhance your list growth.",
      link: {
        text: "Enable Dataships Collection",
      },
    },
  },
} as const;
